<template>
 <div class="xuekezhenduanEntry">
     <router-view></router-view>
 </div>
</template>
<script>
export default {
    name:'xuekezhenduanEntry',
    data(){
        return {

        }
    }
}
</script>

<style style="less" scoped>

</style>